var _path, _polygon, _path2, _polygon2, _path3, _polygon3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolvia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 231.82 26.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Volvia logo svart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.46,13.78"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 1.06 25.12 1.06 25.12 5 19.37 5 27.13 19.08 34.52 5 30.3 5 30.3 1.06 47.75 1.06 47.75 5 41.61 5 30.49 25.79 17.26 25.79 5.56 5 0 5 0 1.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.63,14.1V25.79H81.21v-4h5.46V5.05H81.3v-4h22.82v4H98.47V21.38h6.61s5.28.68,6.23-7.28Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "109.49 1.06 134.61 1.06 134.61 5.05 128.86 5.05 136.63 19.08 144.01 5.05 139.79 5.05 139.79 1.06 157.24 1.06 157.24 5.05 151.1 5.05 139.98 25.79 126.75 25.79 115.05 5.05 109.49 5.05 109.49 1.06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.85,26.75s-17,.62-17-13.37S63,0,63,0H62.9S80.06-.61,80.06,13.38s-17,13.37-17,13.37ZM62.61,3.48s-5.27,0-5.27,9.68,5.36,9.57,5.36,9.57,5.66.55,5.47-9.68S62.61,3.48,62.61,3.48Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "182.13 21.82 176.29 21.82 176.29 5.05 181.94 5.05 181.94 1.06 159.12 1.06 159.12 5.05 164.49 5.05 164.49 21.82 159.03 21.82 159.03 25.79 182.13 25.79 182.13 21.82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199,18.68l-1.65,3.14h4.22v4H184.07v-4h6.14L201.33,1.09h13.23l11.7,20.73h5.56v4H206.7v-4h5.75l-1.68-3.14Zm9.22-4.76L204.68,7.8,201.31,14l-.11.25h7.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolvia);
export default __webpack_public_path__ + "static/media/volvia.67b119fb888410deb1c148a004ead5b1.svg";
export { ForwardRef as ReactComponent };